/**
 * Toggles the visibility of the modal.
 *
 * @param {Event} event - The event object.
 */
function toggleModal(event) {
	const trigger = event.target.closest('[aria-controls]');
	const modalId = trigger ? trigger.getAttribute('aria-controls') : null;
	const modal = modalId ? document.getElementById(modalId) : null;

	if (!modal || !modal.classList.contains('js-modal')) return;

	event.preventDefault();

	if (modal.classList.contains('modal--is-visible')) {
		closeModal(modal);
	} else {
		showModal(modal);
		initModalEvents(modal);
	}
}

/**
 * Initializes modal events for keydown and click.
 *
 * @param {HTMLElement} modal - The modal element.
 */
function initModalEvents(modal) {
	const handleEvent = (event) => handleModalEvent(event, modal);
	modal.addEventListener('keydown', handleEvent);
	modal.addEventListener('click', handleEvent);
}

/**
 * Cancels modal events for keydown and click.
 *
 * @param {HTMLElement} modal - The modal element.
 */
function cancelModalEvents(modal) {
	const handleEvent = (event) => handleModalEvent(event, modal);
	modal.removeEventListener('keydown', handleEvent);
	modal.removeEventListener('click', handleEvent);
}

/**
 * Handles modal events for keydown and click.
 *
 * @param {Event} event - The event object.
 * @param {HTMLElement} modal - The modal element.
 */
function handleModalEvent(event, modal) {
	if (event.type === 'click') {
		handleModalClick(event, modal);
	} else if (event.type === 'keydown') {
		handleModalKeyDown(event, modal);
	}
}

/**
 * Handles the keydown event for the modal.
 *
 * @param {Event} event - The event object.
 * @param {HTMLElement} modal - The modal element.
 */
function handleModalKeyDown(event, modal) {
	if (event.key === 'Escape') {
		closeModal(modal);
	}
}

/**
 * Handles the click event for the modal.
 *
 * @param {Event} event - The event object.
 * @param {HTMLElement} modal - The modal element.
 */
function handleModalClick(event, modal) {
	if (event.target.closest('.js-modal__close') || event.target.classList.contains('js-modal')) {
		event.preventDefault();
		closeModal(modal);
	}
}

/**
 * Shows the modal element.
 *
 * @param {HTMLElement} modal - The modal element.
 */
function showModal(modal) {
	modal.classList.add('modal--is-visible');
	modal.addEventListener('transitionend', handleModalTransitionEnd(modal));
}

/**
 * Handles the transition end event for the modal.
 *
 * @param {HTMLElement} modal - The modal element.
 * @returns {Function} The transition end handler function.
 */
function handleModalTransitionEnd(modal) {
	return function transitionEndHandler() {
		modal.removeEventListener('transitionend', transitionEndHandler);
	};
}

/**
 * Closes the modal element.
 *
 * @param {HTMLElement} modal - The modal element.
 */
function closeModal(modal) {
	modal.classList.remove('modal--is-visible');
	cancelModalEvents(modal);
}

/**
 * Adds click event listener to the document for modal triggers.
 */
function modalListeners() {
	document.addEventListener('click', toggleModal);
}

// Initialize the event listeners when the DOM is fully loaded.
document.addEventListener('DOMContentLoaded', modalListeners);
